<template>
  <div class="float-left">
    <v-tooltip top v-if="page == 'ckeditor'">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="pa-0"
          icon
          min-width="40px"
          v-track="'attach-file-btn-click'"
          @click="openAttachmentModel()"
        >
          <v-icon> mdi-paperclip </v-icon>
        </v-btn>
      </template>
      <span> Attach File </span>
    </v-tooltip>

    <v-btn
      v-else
      outlined
      class="font-weight-bold"
      v-track="'attach-file-btn-click'"
      @click="openAttachmentModel()"
    >
      <v-icon> mdi-plus </v-icon>
      Attach File
    </v-btn>
    <v-dialog v-model="dragDropDialog" width="650">
      <v-card class="pa-2 py-3">
        <v-card-title>
          <div class="mb-0 text-h6">
            <h4 class="font-weight-600">Upload File</h4>
          </div>
        </v-card-title>

        <v-card-text class="body-2">
          <p>
            To add new files, upload from your computer or drag and drop them
            into the box below. Please note the maximum file size is
            {{ maxAllowedFileSize / 1024 }}MB and the expected extensions are:
            JPG, PNG, PDF, Doc.
          </p>

          <div
            class="drag-drop-box pb-2"
            @drop="dropHandler"
            @dragover.prevent="dragOverHandler"
          >
            <div v-if="dragAndDropCapable">
              <div v-if="dropedFiles.length">
                <v-list>
                  <template v-for="(file, index) in dropedFiles">
                    <v-list-item :key="file.name">
                      <v-list-item-avatar v-if="getImagePreview(file)" tile>
                        <v-img :src="getImagePreview(file)"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-avatar v-else>
                        <v-img
                          v-if="file.type === 'application/msword'"
                          src="@/assets/img/doc.svg"
                        ></v-img>
                        <v-img v-else src="@/assets/img/pdf.svg"></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title v-html="file.name">
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-icon>
                        <v-btn @click="removeAttchmentFile(file.name)" icon
                          v-track="'remove-attached-file-btn'"
                          ><v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-list-item-icon>
                    </v-list-item>
                    <v-divider :key="index" class="mx-4"></v-divider>
                  </template>
                </v-list>
              </div>
              <template v-if="dropedFiles.length == 0">
                <p class="text-center pt-5 body-1">Drag and Drop</p>
                <p class="text-center body-1 pb-2">or</p>
              </template>
            </div>
            <div v-else>
              <p>Your browser doesn't support Drag-n-Drop feature.</p>
            </div>
            <div v-show="dropedFiles.length == 0" class="uploadBtn text-center">
              <v-btn
                outlined
                class="font-weight-bold"
                @click="handleFileImport"
                v-track="'upload-file-btn'"
              >
                Upload
              </v-btn>
              <!-- Create a File Input that will be hidden but triggered with JavaScript -->
              <input
                ref="uploader"
                class="d-none"
                type="file"
                multiple="multiple"
                @change="onFileChanged"
              />
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            v-if="dropedFiles.length"
            class="font-weight-bold"
            text
            outlined
            @click="handleFileImport"
            v-track="'add-more-file-btn'"
          >
            <v-icon> mdi-plus </v-icon> Add More
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="font-weight-bold" text @click="dragDropDialog = false"
           v-track="'cancel-dragdrop-dialog-btn'">
            Cancel
          </v-btn>
          <v-btn
            class="font-weight-bold white--text"
            v-track="'save-attachments'"
            id="save-attachments"
            :dark="dropedFiles.length > 0"
            :disabled="dropedFiles.length == 0"
            @click="saveAttachments()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { uploadfileMixin } from "@/mixins/uploadfile.js";

export default {
  name: "uploadFile",
  mixins: [uploadfileMixin],
  props: {
    page: {
      type: String,
    },
  },
  data() {
    return {
      dragDropDialog: false,
      maxAllowedFileSize: 30720,
      selectedFile: null,
      dragAndDropCapable: false,
      dropedFiles: [],
      errorSnackbar: false,
      filesSupportedErrorMsg:
        "Selected files are an unsupported extenstion. The expected exptensions are JPG, PNG, PDF, DOC.",
      fileSizeError:
        "Selected file exceeds the size limit. Maximum file size is 30MB each.",
    };
  },
  mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
  },
  methods: {
    openAttachmentModel() {
      this.dragDropDialog = true;
      this.dropedFiles = [];
    },
    determineDragAndDropCapable() {
      var div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },

    dropHandler(ev) {
      ev.preventDefault();
      if (ev.dataTransfer.items) {
        for (let i = 0; i < ev.dataTransfer.items.length; i++) {
          // If dropped items aren't files, reject them
          if (ev.dataTransfer.items[i].kind === "file") {
            var file = ev.dataTransfer.items[i].getAsFile();
            this.validateUploadedFile(file);
          }
        }
      }
    },

    dragOverHandler(ev) {
      ev.preventDefault();
    },

    removeAttchmentFile(fileName) {
      this.dropedFiles = this.dropedFiles.filter((file) => {
        return fileName !== file.name;
      });
    },

    getImagePreview(file) {
      if (
        file.type === "application/pdf" ||
        file.type === "application/msword"
      ) {
        return false;
      }
      return URL.createObjectURL(file);
    },

    saveAttachments() {
      this.dragDropDialog = false;
      this.$emit("saveAttachment", this.dropedFiles);
    },
  },
};
</script>

<style scoped>
.drag-drop-box {
  min-height: 200px;
  max-height: 250px;
  border-style: dashed;
  border-width: 2px;
  border-color: #ccc;
  overflow: hidden;
  overflow-y: auto;
}
</style>
